import React from 'react';
import { HeaderSkeleton } from './HeaderSkeleton';
import { SearchBarAndFiltersSkeleton } from './SearchBarAndFiltersSkeleton';
import { DataTableSkeleton } from './DataTableSkeleton';
import { PaginationSkeleton } from './PaginationSkeleton';

export const ReceiptsPageSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F5F8F9]">
      <div className="max-w-[1600px] mx-auto p-6 space-y-8 pb-24 lg:pb-8">
        <HeaderSkeleton buttonCount={1} />

        <div className="flex flex-wrap gap-6">
          <div className="flex-1">
            <SearchBarAndFiltersSkeleton filterCount={3} />
          </div>
        </div>

        <div className="relative">
          <DataTableSkeleton
            rowCount={10}
            columnCount={8}
            withCheckbox={false}
            withActions={true}
          />
        </div>

        <PaginationSkeleton />
      </div>
    </div>
  );
};
